import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-banner-sep',
    templateUrl: './banner-sep.component.html',
    styleUrls: ['./banner-sep.component.scss'],
    standalone: false
})
export class BannerSepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
